import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../helpers/react.js";
import { Font } from "../Font/index.js";
import { IconWrapper } from "../IconWrapper/index.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import '../../assets/index9.css';const chip = "_chip_31hj2_1";
const icon = "_icon_31hj2_25";
const text = "_text_31hj2_30";
const unchecked = "_unchecked_31hj2_36";
const checked = "_checked_31hj2_63";
const empty = "_empty_31hj2_120";
const s = {
  chip,
  icon,
  text,
  unchecked,
  checked,
  "default": "_default_31hj2_91",
  empty
};
const VARIANT_CLASS_NAME_MAP = {
  default: s.default,
  checked: s.checked,
  unchecked: s.unchecked,
  empty: s.empty
};
const Chip = withThemeAndSize(
  forwardRef(
    ({ children, className, variant = "default", leftIcon = null, rightIcon = null, contentClassName, ...rest }, ref) => {
      return /* @__PURE__ */ jsx(Font, { type: "text", size: 14, weight: "medium", children: /* @__PURE__ */ jsxs("button", { ...rest, className: clsx(className, s.chip, VARIANT_CLASS_NAME_MAP[variant]), ref, children: [
        leftIcon && /* @__PURE__ */ jsx(IconWrapper, { className: s.icon, size: "md", children: leftIcon }),
        /* @__PURE__ */ jsx("span", { className: clsx(s.text, contentClassName), children }),
        rightIcon && /* @__PURE__ */ jsx(IconWrapper, { className: s.icon, size: "md", children: rightIcon })
      ] }) });
    }
  )
);
export {
  Chip
};
